import { render, staticRenderFns } from "./QuoteTemplateView.vue?vue&type=template&id=63c80890"
import script from "./QuoteTemplateView.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c80890')) {
      api.createRecord('63c80890', component.options)
    } else {
      api.reload('63c80890', component.options)
    }
    module.hot.accept("./QuoteTemplateView.vue?vue&type=template&id=63c80890", function () {
      api.rerender('63c80890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quotetemplate/QuoteTemplateView.vue"
export default component.exports